import { graphql } from 'gatsby';
import React, { useContext } from 'react';

import EmailOnly, { EmailOnlyLayouts } from '../../email-only/email-only';
import LayoutContext from '../../../contexts/layoutContext';
import {
  Drupal_ParagraphNineteenCtas,
  Drupal_ParagraphNineteenEmailOnly
} from '../../../generated/graphql';
import NineteenCta from '../nineteen-cta/nineteen-cta';

interface Props {
  entity: Drupal_ParagraphNineteenCtas | Drupal_ParagraphNineteenEmailOnly;
}

const NineteenAction = (action: Props) => {
  const {
    language: { langPrefix }
  } = useContext(LayoutContext);

  if (action.entity.entityBundle === 'nineteen_email_only') {
    return (
      <EmailOnly
        layout={
          langPrefix === 'en'
            ? EmailOnlyLayouts.Uneven
            : EmailOnlyLayouts.Stacked
        }
      />
    );
  }

  if (action.entity.entityBundle === 'nineteen_ctas') {
    const { fieldNineteenCtas } = action.entity as Drupal_ParagraphNineteenCtas;
    return (
      <>
        {fieldNineteenCtas!.map((nineteenCta, i) => (
          <NineteenCta
            key={i}
            entity={nineteenCta!.entity!}
            primary={i === 0}
          />
        ))}
      </>
    );
  }

  return <div />;
};

export default NineteenAction;

export const query = graphql`
  fragment nineteenAction on Drupal_Paragraph {
    entityBundle
    ... on Drupal_ParagraphNineteenCtas {
      fieldNineteenCtas {
        entity {
          ...nineteenCta
        }
      }
    }
  }
`;
